// extracted by mini-css-extract-plugin
module.exports = {"deleteTextButton":"styles_deleteTextButton__b_Gzq","fadeInOut":"styles_fadeInOut__ymD9g","loader":"styles_loader__LiCtj"};